import { Box, HStack, Separator, Text, VStack } from "@chakra-ui/react";

export type Detail = { label: string; value: React.ReactNode };

type Props = { details: Detail[] };

const DetailList = ({ details }: Props): JSX.Element => (
  <VStack gap={4} align="stretch">
    {details.map((detail, index) => (
      <Box key={detail.label}>
        <HStack justify="space-between" mb={2}>
          <Text fontWeight={600} color="gray.600">
            {detail.label}:
          </Text>
          <Text color="gray.700">{detail.value}</Text>
        </HStack>
        {index < details.length - 1 && <Separator borderColor="gray.200" />}
      </Box>
    ))}
  </VStack>
);

export default DetailList;
